module.exports = __webpack_public_path__ + "static/media/leozao.33081a9d.png";